import React from 'react';

import { GetRosaCategoriesResponse } from '../../../hooks/useGetRosaCategories';
import { ActionPlanSectionContext } from './context';
import { Content } from './Content';
import { Header } from './Header';
import * as S from './styles';

interface SectionProps {
	name: string;
	score: number;
	description: string;
	fieldName: string[];
	category: GetRosaCategoriesResponse;
}

export function Section({ category, name, description, score, fieldName }: Readonly<SectionProps>) {
	const values = {
		name,
		score,
		category,
		description,
		form_field_name: fieldName
	};

	return (
		<ActionPlanSectionContext.Provider value={values}>
			<S.Container gutter={[0, 20]}>
				<Header />
				<Content />
			</S.Container>
		</ActionPlanSectionContext.Provider>
	);
}
